import React from "react";
import AccordingHeaderPlaceholder from "./AccordingHeaderPlaceholder";
import VehiclePlaceholder from "./VehiclePlaceholder";

const VehiclesListPlaceHolder = ({ type = "" }) => {
  const count = type === "driver" || type === "poi" ? 15 : 8;
  const countArray = new Array(count).fill(1);
  return (
    <React.Fragment>
      {countArray.map((_, index) => (
        <VehiclePlaceholder key={index} type={type} />
      ))}
    </React.Fragment>
  );
};

export default VehiclesListPlaceHolder;
